import React, { useState, useEffect } from 'react';
import Footer from '../../Components/Footer/Footer';
import './SafetyCenter.css';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';

function SafetyCenter() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 900);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <>
            <HomeNav />
            <div className="safety-center-container">
                <h2 className="safety-center-title">Safety Center – Astra Clean</h2>
                <p className="safety-center-intro">
                    At <strong>Astra Clean</strong>, your safety, health, and peace of mind are our highest priorities. 
                    We are committed to maintaining a safe and trustworthy cleaning experience for our customers, staff, and the environments we serve.
                </p>

                <div className="safety-center-section">
                    <h3 className="safety-center-section-title">🧑‍🔧 Trained & Trusted Professionals</h3>
                    <p className="safety-center-text">
                        All Astra Clean team members are carefully selected and trained to follow strict safety and hygiene standards. 
                        Our staff is experienced in handling cleaning equipment, products, and procedures responsibly to ensure safe and effective results.
                    </p>
                </div>

                <div className="safety-center-section">
                    <h3 className="safety-center-section-title">🧴 Safe Cleaning Products</h3>
                    <p className="safety-center-text">
                        We use high-quality cleaning products that are effective yet safe for homes, offices, and shared spaces. 
                        Whenever possible, we choose products that are environmentally responsible and safe for children, pets, and sensitive environments.
                    </p>
                </div>

                <div className="safety-center-section">
                    <h3 className="safety-center-section-title">🧼 Hygiene & Sanitation Standards</h3>
                    <p className="safety-center-text">
                        Our team follows proper sanitation practices, including the use of protective gear when required, to prevent 
                        cross-contamination and maintain a healthy environment during every cleaning service.
                    </p>
                </div>

                <div className="safety-center-section">
                    <h3 className="safety-center-section-title">🏠 Respect for Your Space</h3>
                    <p className="safety-center-text">
                        We treat your property with the utmost care and respect. Our professionals follow clear guidelines to protect 
                        your belongings, furniture, and surfaces while performing their work.
                    </p>
                </div>

                <div className="safety-center-section">
                    <h3 className="safety-center-section-title">🔐 Privacy & Security</h3>
                    <p className="safety-center-text">
                        Your privacy matters to us. All customer information is kept confidential and used only for service-related purposes. 
                        Our staff is trained to respect your privacy and maintain professionalism at all times.
                    </p>
                </div>

                <div className="safety-center-section">
                    <h3 className="safety-center-section-title">⚠️ Reporting Safety Concerns</h3>
                    <p className="safety-center-text">
                        If you ever feel uncomfortable or notice a safety concern during or after our service, please contact us immediately 
                        through our official support channels. We take all concerns seriously and act promptly to resolve them.
                    </p>
                </div>

                <div className="safety-center-section">
                    <h3 className="safety-center-section-title">🤝 Our Commitment</h3>
                    <p className="safety-center-text">
                        Astra Clean is dedicated to creating a safe, clean, and healthy environment for every customer. We continuously review 
                        and improve our safety practices to meet high industry standards and exceed expectations.
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default SafetyCenter;
